<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
         
      </div>

      <!-- 版权信息 -->
      <div class="footer-bottom">
        <div class="copyright">
          ©2021-2025 Zhixin & Partners Law Firm Ltd. ALL RIGHTS RESERVED.
          <a href="https://beian.miit.gov.cn" target="_blank" class="icp-link">
            <span style="margin-left: 15px;">京ICP备2026032253号</span>
          </a>
         <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802048906" target="_blank" class="icp-link">
            <span style="margin-left: 15px;">京公网安备11010802048906号</span>
          </a>
         <div class="qq-avatar" style="margin-left: 20px;">
            <img src="@/assets/images/tellphone.png" alt="QQ" class="qq-icon">
            13120454865、18600895993
          </div>
          
        </div>
         <div style="display: flex;flex-direction: row;margin-top:15px;align-items:center">
           <div class="copyright"  >
            微信公众号：
            <img src="@/assets/images/图片1.png"    style="width: 80px;height: 80px;margin-left: 10px;margin-right:40px">
          领英帐号：
            <img src="@/assets/images/图片2.png" style="width: 80px;height: 25px;margin-left: 10px;">
            <img src="@/assets/images/图片3.png" style="width: 80px;height: 80px;margin-left: 10px;">
            <div class="qq-avatar" style="display:inline-flex;margin-left:10px">
              <img src="@/assets/images/QQ.png" alt="QQ" class="qq-icon">
              2892489300、2557556908
            </div>
          </div>
         </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.qq-avatar {
  height: 32px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qq-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.footer {
  background-color: #333;
  color: white;
  padding: 4rem 0 2rem;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  margin-bottom: 3rem;
}

/* 通用部分样式 */
.footer-section {
  color: #f8f9fa;
}

.footer-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: white;
}

/* 联系信息样式 */
.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}

.info-item i {
  font-size: 1.2rem;
  color: #007bff;
  margin-top: 0.25rem;
}

.info-text {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #adb5bd;
}

/* 链接列表样式 */
.link-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.link-item {
  margin-bottom: 0.75rem;
}

.link {
  font-size: 0.9rem;
  color: #adb5bd;
  text-decoration: none;
  transition: color 0.3s ease;
}

.link:hover {
  color: #007bff;
}

/* 社交媒体样式 */
.social-links {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #495057;
  border-radius: 50%;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: #007bff;
  transform: translateY(-3px);
}

.social-link i {
  font-size: 1.2rem;
}

/* 订阅样式 */
.newsletter-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: white;
}

.newsletter-input {
  margin-bottom: 1rem;
}

.newsletter-input .el-input__inner {
  background-color: #495057;
  border-color: #6c757d;
  color: white;
  border-radius: 4px;
}

.newsletter-input .el-input__inner::placeholder {
  color: #adb5bd;
}

.newsletter-button {
  background-color: #007bff;
  border-color: #007bff;
  width: 100%;
}

.newsletter-button:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

/* 底部版权信息样式 */
.footer-bottom {
  border-top: 1px solid #495057;
  padding-top: 2rem;
  display: flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.copyright {
  font-size: 0.9rem;
  color: #adb5bd;
  text-align: left;
  display: flex;
  flex-direction: row;
    display: flex;
  align-items: center;
  width: 100%;
}

.legal-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.legal-link {
  font-size: 0.9rem;
  color: #adb5bd;
  text-decoration: none;
  transition: color 0.3s ease;
}

.legal-link:hover {
  color: #FF631E;
}

.icp-link {
  color: #adb5bd;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #FF631E;
}

.separator {
  color: #adb5bd;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
  
  .legal-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .footer {
    padding: 3rem 0 1.5rem;
  }
  
  .footer-title {
    font-size: 1.2rem;
  }
}
</style>